import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';

export const PricingSection = ({ plans, onSelectPlan }) => (
  <section id="pricing" className="py-20 bg-gradient-to-b from-sky-900/20 to-transparent">
    <div className="max-w-6xl mx-auto px-4">
      <div className="text-center mb-16">
        <Badge className="bg-orange-500/10 text-orange-400 border-orange-500/20 mb-4">Planes y Precios</Badge>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Elige tu Plan Perfecto</h2>
        <p className="text-sky-200/60 max-w-2xl mx-auto">Sin contratos. Cancela cuando quieras. Comienza con el plan que mejor se adapte a ti.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {plans.map((plan) => {
          const Icon = plan.icon;
          return (
            <Card
              key={plan.id}
              className={`relative border-2 transition-all duration-300 overflow-hidden ${
                plan.popular
                  ? 'border-orange-500 scale-105 shadow-2xl shadow-orange-500/20 bg-sky-900/40'
                  : 'border-sky-800/30 hover:border-sky-700/50 bg-sky-900/20'
              }`}
              data-testid={`plan-${plan.id}`}
            >
              {plan.popular && (
                <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-center py-2 text-sm font-medium">
                  Mas Popular
                </div>
              )}
              <CardContent className={`p-8 ${plan.popular ? 'pt-14' : ''}`}>
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${plan.color} flex items-center justify-center mb-6`}>
                  <Icon className="text-white" size={28} />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                <div className="flex items-baseline gap-1 mb-6">
                  <span className="text-4xl font-black text-white">${plan.price}</span>
                  <span className="text-sky-300/60">{plan.period}</span>
                </div>
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, fIdx) => (
                    <li key={`f-${fIdx}`} className="flex items-center gap-3 text-sky-100">
                      <CheckCircle2 size={18} className="text-sky-400 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                  {plan.notIncluded.map((feature, fIdx) => (
                    <li key={`ni-${fIdx}`} className="flex items-center gap-3 text-sky-300/40 line-through">
                      <div className="w-[18px] h-[18px] rounded-full border border-sky-700/50 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  onClick={onSelectPlan}
                  className={`w-full py-6 text-lg rounded-xl ${
                    plan.popular
                      ? 'bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white'
                      : 'bg-sky-800/50 hover:bg-sky-700/50 text-white'
                  }`}
                >
                  Comenzar Ahora
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
